import throttle from "lodash.throttle";
import $ from "jquery";

const DEFAULT_SCROLL_PADDING = 96;

// Added check for current page - Jonathan Dallas - Sept 2021

// This code looks for
// 1. A hash in the url and will scroll to a matching id on the page if found
// 2. Anchor links on the page containing "#" and will scroll the page to a matching target if they exist.
//
// Targets on the page should always be coded as <a id="value"></a>

export default function inPageNavigation(links = []) {
  const targets = [];
  const animationTime = 750;
  let isScrolling = false;
  let activeLinkIndex = 0;

  [...links].forEach((link, index) => {
    // check if the link is more than just "#" and is pointing to the current page
    if (
      link.href.length > 1 &&
      (link.href[0] === "#" || link.href.includes(window.location.pathname))
    ) {
      initLinks(link, index);
    }
  });

  function initLinks(link, index) {
    const href = link.getAttribute("href");
    const hash = `#${href.split("#")[1]}`;

    let target = null;

    try {
      target = document.querySelector(hash);
    } catch (e) {
      console.warn(`${hash} is not a valid target`);
    }

    if (target) {
      target.dataset.index = index;
      targets.push(target);

      link.addEventListener("click", (e) => {
        e.preventDefault();

        // manually move the aria current
        // scroll event might do this as well, but better to make sure
        setCurrentLink(link);

        scrollPageTo(target);
      });
    }

    handleScroll(targets);
    window.addEventListener(
      "scroll",
      throttle(() => {
        handleScroll(targets);
      }, animationTime),
    );
  }

  function handleHashUrl() {
    const urlHash = window.location.hash;
    if (!urlHash || urlHash.length <= 1) {
      return;
    }

    const target = document.querySelector(urlHash);

    if (target) {
      let customScrollOffset = target.dataset.customScrollOffset
        ? parseInt(target.dataset.customScrollOffset, 10)
        : undefined;

      scrollPageTo(target, customScrollOffset);

      // wait for images to fill space and readjust.
      window.setTimeout(() => {
        scrollPageTo(target, customScrollOffset);
      }, 750);
    }
  }

  function scrollPageTo(target, scrollPadding = DEFAULT_SCROLL_PADDING) {
    const _scrollPadding =
      typeof scrollPadding === "number" && !isNaN(scrollPadding)
        ? scrollPadding
        : DEFAULT_SCROLL_PADDING;

    // find the offset to the target
    // remove a little so it's not at the top of the page
    let offset = getOffset(target).top - _scrollPadding;

    isScrolling = true;

    $("html,body").animate(
      {
        scrollTop: offset,
      },
      animationTime,
      function () {
        offset = getOffset(target).top - _scrollPadding;
        // lazy loaded images are throwing off the position so do a quick re-adjustment.
        $("html,body").animate(
          {
            scrollTop: offset,
          },
          50,
          function () {
            offset = getOffset(target).top - _scrollPadding;
            target.setAttribute("tabIndex", "-1");
            target.focus();
            target.removeAttribute("tabIndex");
            window.scrollTo(0, offset); // reset any scrolling due to focus being set.
            isScrolling = false;
          },
        );
      },
    );
  }

  // on page scroll, move the aria-current attribute to the appropriate link
  function handleScroll(targets) {
    if (isScrolling) {
      return;
    }

    const target = getCurrentTarget(targets);

    if (target && target.dataset.index !== activeLinkIndex) {
      activeLinkIndex = parseInt(target.dataset.index);
      setCurrentLink(links[activeLinkIndex]);
    }
  }

  // Takes a Node List of anchor tags on the page and a callback function
  function getCurrentTarget(targets) {
    return [...targets].find((target) => {
      const rect = target.getBoundingClientRect();
      return (
        rect.top < window.innerHeight / 2 + 100 &&
        rect.bottom > window.innerHeight / 2 - 100
      );
    });
  }

  function getOffset(target) {
    const rect = target.getBoundingClientRect();
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  }

  function setCurrentLink(link) {
    [...links].forEach((link) => {
      link.removeAttribute("aria-current");
    });

    link.setAttribute("aria-current", "location");
  }

  return {
    scrollPageTo,
    getOffset,
    handleHashUrl,
    getCurrentTarget,
  };
}
